// 用户实名认证
import * as auth from '@/utils/auth'

const state = {
    authInfo: auth.getAuthInfo(),
    obligeeList: auth.getObligeeList(),
}
const getters = {
    authInfo(state) {
        return state.authInfo;
    },
    obligeeList(state) {
        return state.obligeeList;
    }
}
const mutations = {
    setAuthInfo(state,data) {
        state.authInfo = data;
        auth.setAuthInfo(data);
    },
    setObligeeList(state,data) {
        state.obligeeList = data;
        auth.setObligeeList(data);
    }
}
export default {
    state,
    getters,
    mutations
}
